<template>
  <b-modal size="xl" id="modal-detail-brs" centered :title="detail.title" ok-only>
    <div class="card p-3 mt-3">
      <div class="row row-cols-1 row-cols-md-4 mb-3 pt-3">
        <div class="col">
          <div class="row align-items-center">
            <div class="col-auto">
              <div class="avatar avatar-sm">
                <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                  <i class="fe fe-calendar"></i>
                </div>
              </div>
            </div>
            <div class="col ms-n2">
              <h4 class="mb-1 font-weight-bold">Delivery Date</h4>
              <small class="text-body-secondary"
                ><span>{{ convertMonth(detail?.delivery_date) }}</span>
              </small>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row align-items-center">
            <div class="col-auto">
              <div class="avatar avatar-sm">
                <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                  <i class="fe fe-dollar-sign"></i>
                </div>
              </div>
            </div>
            <div class="col ms-n2">
              <h4 class="mb-1 font-weight-bold">Relocation Value</h4>
              <small class="text-body-secondary"
                ><span>{{ formatCurrency(detail?.relocate_value, 'Rp. ') }}</span>
              </small>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row align-items-center">
            <div class="col-auto">
              <div class="avatar avatar-sm">
                <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                  <i class="fe fe-tag"></i>
                </div>
              </div>
            </div>
            <div class="col ms-n2">
              <h4 class="mb-1 font-weight-bold">IM Name</h4>
              <small class="text-body-secondary"
                ><span>{{ detail.im_number || '-' }}</span>
              </small>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row align-items-center">
            <div class="col-auto">
              <div class="avatar avatar-sm">
                <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                  <i class="fe fe-tag"></i>
                </div>
              </div>
            </div>
            <div class="col ms-n2">
              <h4 class="mb-1 font-weight-bold">IM Project</h4>
              <small class="text-body-secondary"
                ><span>{{ selectedImProject?.project_name || '-' }}</span>
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-2 g-3 mt-2">
        <div class="col">
          <div class="card p-3 h-100">
            <label class="font-weight-bold">From</label>
            <div class="row row-cols-1 row-cols-md-2 gx-3 gy-5 mb-2">
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Departmen From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.department_name_from }}</span>
                    </small>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Fund From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ `${detail?.type_from} | ${detail?.fund_from}` }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL From</h4>
                    <small class="text-body-secondary">
                      <span>
                        {{ `${detail?.gl_code_from} | ${detail?.budget_item_from}` }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.budget_task_from }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card p-3 h-100">
            <label class="font-weight-bold">To</label>
            <div class="row row-cols-1 row-cols-md-2 gx-3 gy-5 mb-2">
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Departmen To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.department_name_to }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Fund To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ `${detail?.type_to} | ${detail?.fund_to}` }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL To</h4>
                    <small class="text-body-secondary">
                      <span>
                        {{ `${detail?.gl_code_to} | ${detail?.budget_item_to}` }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.budget_task_to }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { formatCurrency } from '@/utils/formatNumber';
import moment from 'moment';

export default {
  name: 'ModalDetailBRS',
  props: {
    detail: {
      type: Object || null,
      required: true,
    },
  },
  computed: {
    selectedImRelocate() {
      return this.detail?.imData?.selectedImRelocate || {};
    },
    selectedImProject() {
      return this.detail?.imData?.selectedImProject || {};
    },
  },
  methods: {
    formatCurrency,
    convertMonth(dat) {
      if (dat) {
        return moment(dat).format('DD MMMM YYYY');
      } else {
        return '-';
      }
    },
  },
  mounted() {},
};
</script>
